import React, { useState } from "react";
import MaterialUIComboBox from "../../ComboBox/MaterialUIComboBox";
import { useFleetTypes } from "../../../providers/FleetTypeProvider";

interface FleetTypeFilterProps {
  fleetTypeValue: string;
  onFleetTypeChange: (fleet: string) => void;
  onFleetTypeError: (error: boolean) => void;
  error: boolean; 
}

const FleetTypeFilter: React.FC<FleetTypeFilterProps> = ({
  fleetTypeValue,
  onFleetTypeChange,
  onFleetTypeError,
  error
}) => {
  const { fleetTypes } = useFleetTypes();
  const [isError, setIsError] = useState(false);

  const options = Array.isArray(fleetTypes)
    ? fleetTypes.map((item) => item.FleetType)
    : [];

  const handleChange = (event: any, value: string | null) => {
    const newValue = value?.toUpperCase() || "";
    onFleetTypeChange(newValue);
    const hasError = newValue !== "" && !options.includes(newValue);
    setIsError(hasError);
    onFleetTypeError(hasError);
  };

  return (
    <div className="form-input">
      <MaterialUIComboBox
        label="Fleet"
        value={fleetTypeValue}
        onChange={handleChange}
        options={options}
        className="fleet-type-filter-combobox"
        freeSolo={false} 
        error={error}
        helperText={error ? "invalid entry" : ""}
        inputProps={{
          "data-testid": "fleet-Type"
        }}
        noOptionsText="No matching option"
      />
    </div>
  );
};

export default FleetTypeFilter;
